<template>
	<div class="ma-0 pa-0">
	
		<v-dialog v-model="saveDialog" width="72%" elevation="8" fade>
			<v-card :color="feedback_type">
				<div :class="`headline text-center py-4`">{{ feedback_msg }}</div>
			</v-card>
		</v-dialog>

		<ConfirmDialog
			v-if="confirmDialog"
			v-model="sections"
			:moduleKey="moduleKey"
			@cancel="confirmDialog=false"
			@confirm="saveValues(date_submitted && !readonly ? 'resubmitted' : 'review')"
			@navigate="navigateToSection"
		/>

		<v-dialog
			v-model="techSupportDialog"
			width="60%"
		>
			<v-card>
				<v-card-title class="headline primary darken-1 white--text py-4 mx-0 text-center">
					<div>Some people have reported not being able to load the questionnaire ...</div>
				</v-card-title>
	
				<v-card-text>
					<div class="d-block my-4">If you are experiencing this too, please "hard refresh" your browser by clicking the button below.</div>
					<div class="d-block mt-6 mb-4 text-center">
						<HardRefresh buttonText="Refresh Questionnaire" />
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	
		<v-dialog
			v-model="helpDialog"
			width="60%"
		>
			<v-card>
				<v-card-title class="headline primary darken-1 white--text py-4 mx-0 text-center">
					<div class="" style="width: 100%">The First Step In Maximizing Your Value</div>
				</v-card-title>
	
				<v-card-text>
					<div class="my-3">
						<h3>What to expect during the questionnaire:</h3>
						<p class="my-3">
							<ol>
								<li>8 sections
									<p>There are 8 sections to complete, you may need to complete additional documents depending on your practice. We will let you know if we believe we will need additional documents.</p>
								</li>
								<li>Estimated Completion
									<p>This one really depends. If this isn&apos;t your first rodeo, you should be able to complete the questionnaire within two hours. However, getting documents and reports can take some time to achieve. We&apos;ll touch on this again in section 6.</p>
								</li>
								<li>We&apos;re Here For You!
									<p>We understand that getting a valuation is time consuming and not something you always want to be doing. We make it as easy as possible to understand your value and help you every step of the way.</p>
								</li>
							</ol>
						</p>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	
		<div id="questionnaire" :class="questionnaire_visible">
			<template>
				<v-layout column :style="isAdmin ? `` : `background-color: #EFEFEF`">
					<div class="d-flex d-block">
						<!-- <v-btn
							icon
							small
							color="primary"
							class="d-inline"
							@click="helpDialog = true">
							<v-icon>mdi-lifebuoy</v-icon>
						</v-btn> -->
						<v-spacer></v-spacer>
						<div v-if="isAutoSaving" class="d-flex d-inline mr-3 px-3 align-center">
							<span class="general_grey--text align-center">{{ savingText }}</span>
							<v-progress-circular indeterminate color="general_grey" class="ml-2 align-center" size="24" width="2"></v-progress-circular>
						</div>

						<v-icon v-if="!isQuestionsOnly" small color="primary" class="mx-2">mdi-lock</v-icon>
						
						<v-btn
							v-if="!isPartner && !isQuestionsOnly"
							color="primary"
							@click="isAdmin ? adminQuestionniareSave() : handleSubmitReview()"
							class="d-inline px-3 white--text elevation-2"
							:disabled="isAdmin ? isAutoSaving : checkReadOnly || sugar">
							<span v-if="moduleKey != 'buyer'">{{ saveButtonText }}</span>
							<span v-else>Update Profile</span>
						</v-btn>
					</div>
					<div class="d-flex d-block align-center my-1 caption font-weight-thin general_grey--text justify-space-between">
						<div class="d-flex d-inline">
							<div v-if="!isQuestionsOnly" class="d-inline ml-1">
								{{ completedSections.length }} of {{ progressTabs.length }} sections completed.
							</div>
							<div v-if="!isQuestionsOnly && moduleKey == 'buyer' && status" class="d-inline mx-9">
								Eligible to Express Interest: <strong>{{ status == 'completed' ? 'Yes' : 'Not Yet' }}</strong>
							</div>
						</div>

						<!-- <v-spacer></v-spacer> -->

						<div class="d-flex d-inline justify-end">
							<div class="d-inline warning--text" 
								style="cursor: pointer" 
								@click="techSupportDialog = true">
								Questionnaire not loading?
							</div>

							<div class="d-inline">
								<div v-if="last_saved" class="ml-12">Last Saved: {{ last_saved }}</div>
								<div v-else>&nbsp;</div>
							</div>
						</div>
					</div>
				</v-layout>
			</template>
	
			<div :class="isAdmin ? '' : 'elevation-4'">
				<div class="py-3" style="background-color: #FFF"> <!-- style="background-color: #37383C"  |  dark  background-color="#37383C" -->
					<v-tabs
						v-model="currentSectionValue"
						:grow="grow"
						background-color="#FFF"
						color="grow"
						class="sansation"
						center-active
						show-arrows
						@change="handleTabChange"
					>
						<v-tab
							v-for="(tab, idx) in visibleTabs"
							:key="`top-tab-${tab.value}-${idx}`"
							:href="`#${tab.value}`"
							class="px-4 grow--text"
							active-class='act_tb'
							active="true"
							:style="(idx+1) < tabs.length ? 'border-right:1px solid #ddd' : ''"
						>
							{{ tab.title }}
							<v-icon  
								class="ml-2" 
								:class="!(tab.section.unfinished && tab.section.unfinished.length > 0) ? isAdmin ? 'q_secondary--text text-lighten-1' : 'secondary--text text-lighten-1' : 'grey--text text--lighten-4'">
								mdi-checkbox-marked
							</v-icon>
						</v-tab>
					</v-tabs>
				</div>
	
				<v-progress-linear
					:active="progress_active"
					background-opacity="0.3"
					buffer-value="100"
					height="8"
					striped
					stream
					:value="completedSectionsPercent"
					:color="isAdmin ? 'q_secondary lighten-1' : 'secondary lighten-1'"
					class="d-block"
					style="border-right: 1px solid #E9F5D0">
				</v-progress-linear>
	
				<v-card v-if="!Object.keys(questionnaire_data).length" class="text-center py-12 elevation-0">
					<v-progress-circular 
						indeterminate 
						color="primary" 
						:class="show_extraWaiting ? 'mt-12' : 'my-12'" 
						size="84" 
						width="5">
					</v-progress-circular>
					<div v-if="show_extraWaiting" class="text-center waiting_text mt-6 mb-0">
						... this one is taking a little longer to load, hang in there ...
					</div>
				</v-card>

				<QuestionnaireTemplate 
					v-if="questionnaireDataLength"
					v-model="questionnaire_values"
					:moduleKey="moduleKey"
					:projectId="projectId"
					:userId="userId"
					:questionnaireData="questionnaire_data"
					:readonly="checkReadOnly"
					:validatingSubmission="validatingSubmission"
					:handleTabChange="handleTabChange"
					:openQuestionnaire="openQuestionnaire" />

				<v-tabs
					grow
					hide-slider
					class="sansation bottom_border"
				>
					<v-tab
						v-for="(di, navIdx) in nav_tabs"
						:key="`nav-tab-${di.value}-${di.title}-${navIdx}`"
						:href="`#${di.value}`"
						@click="['UPDATE PROFILE', saveButtonText].includes(di.title) ? (isQuestionsOnly ? null : (isAdmin ? adminQuestionniareSave() : handleSubmitReview())) : handleTabChange(di.value)">
	
						<v-icon v-if="di.title == 'PREV SECTION'" class="mr-1" color="primary">mdi-chevron-left</v-icon>
						<span v-if="di.title != ''" :class="`font-weight-bold ${di.color}`" style="letter-spacing: .175rem">{{ di.title }}</span>
						<v-icon v-if="di.title == 'NEXT SECTION'" class="ml-1" color="primary">mdi-chevron-right</v-icon>
					</v-tab>
				</v-tabs>
			</div>
		</div>
	</div>
	</template>
	
	<script>
	import axios from 'axios'
	import Cookie from 'js-cookie'
	import { debounce } from 'debounce'
	import appUrls from '../../helpers/environment'
	import { safeParseJson } from '../../helpers/safe-json'
	import Store from '../store'
	import questionnaireStore from '../questionnaire-store'
	import { checkVisibility, dataTimeDisplayFormatter } from '../utilities'
	
	import QuestionnaireTemplate from './questionnaire-template'
	import ConfirmDialog from './confirm-dialog'
	import { GROW_TABS } from '../constants'
	import HardRefresh from '../shared/hardRefresh'

	const PARTNER_INFO_TAB_TYPE = 'partner_info'
	const ADMIN_ONLY_TAB_TYPE = 'admin_only'
	const PARTNER_FIRM_GROUP_ID = 8
	const PARTNER_INFO_READONLY_GROUP_IDS = [1, 2, 3, 6, 8]
	
	const isEquivalent = (a, b) => {
		// Create arrays of property names
		var aProps = Object.getOwnPropertyNames(a);
		var bProps = Object.getOwnPropertyNames(b);
	
		// If number of properties is different,
		// objects are not equivalent
		if (aProps.length != bProps.length) {
			return false;
		}
	
		for (var i = 0; i < aProps.length; i++) {
			var propName = aProps[i];
	
			// If values of same property are not equal,
			// objects are not equivalent
			if (a[propName] !== b[propName]) {
				return false;
			}
	
			// If values of same property are not equal,
			// objects are not equivalent
			if (typeof a[propName] === 'object' && typeof b[propName] === 'object') {
				if(!isEquivalent(a[propName], b[propName])) {
					return false;
				}
			}
		}
	
		// If we made it this far, objects
		// are considered equivalent
		return true;
	}
	
export default {
	name: 'Questionnaire',
	
	components: {
		QuestionnaireTemplate,
		ConfirmDialog,
		HardRefresh
	},
	
	 props: {
		moduleId: String,
		userId: String,
		moduleKey: String,
		projectId: String,
		questionsOnly: {
			type: Boolean,
			default: false
		},
		date_submitted: String,
		status: String,
		// introActive: Boolean,
		readonly: Boolean,
		needsHardRefresh: Boolean,
		getCurrentProject: Function,
		openQuestionnaire: Function,
		parentProjectId: String,
		resolutionData: Object
	},
	
	data () {
		return {
			rowHeight: 24,
			rows: 1,
			sections: {},
			tabs: [],
			nav_tabs: [],
			model: null,
			last_saved: '',
			// intro_visible: 'd-none', // this.introActive ? 'd-block' : 'd-none',
			questionnaire_visible: 'd-block', // this.introActive ? 'd-none' : 'd-block',
			enitityFormationDate: String,
			progress_active: true,

			helpDialog: false,

			isAdmin: false,
			isAutoSaving: false,

			confirmDialog: false,
			saveDialog: false,
			feedback_type: '',
			feedback_msg: '',
			validatingSubmission: false,

			questionnaire_xhr: {},
			questionnaire_data_cache: {},
			questionnaire_data: {},
			questionnaire_values: {},
			currentSection: null,
			completedSections: [],
			completedSectionsPercent: 0,
			intialLoad: true,
			show_extraWaiting: false,

			isPartner:false,
			questionnaireUserGroupIDs: [],
			projectUsers: [],

			techSupportDialog: false,
			resubmitted_questionnaire: false,
		}
	},
	
	computed: {
		isQuestionsOnly: function () {
			return this.questionsOnly || !this.projectId || !this.userId
		},

		checkReadOnly() {
			this.questionnaireUserGroupIDs = questionnaireStore.userInfo && questionnaireStore.userInfo.group_ids || [];
			this.isPartner = this.questionnaireUserGroupIDs && this.questionnaireUserGroupIDs.includes(PARTNER_FIRM_GROUP_ID)

			// Short circuit if not readonly
			if (!this.readonly || this.isQuestionsOnly) return false;

			const currentTabType = this.currentSection && this.currentSection.tab_type
			if (currentTabType !== PARTNER_INFO_TAB_TYPE) return true;

			// Check if user has special roles for this section
			const userGroupIds = this.questionnaireUserGroupIDs.map(Number) || [];
			const hasSpecialRole = PARTNER_INFO_READONLY_GROUP_IDS.some(role => userGroupIds.includes(role));

			return !hasSpecialRole;
		},

		sugar: function () {
			return Cookie.get('sugar') == 'true' ? true : false
		},

		// Filtered tabs to only show visible tabs
		visibleTabs: function () {
			return this.tabs.filter((tab) => {
				if (!(tab.section && tab.section.visible)) return false
				if (tab.tab_type !== PARTNER_INFO_TAB_TYPE) return true

				return this.projectUsers.some((user) => {
					const groupIds = Array.isArray(user && user.group_ids) ? user.group_ids.map(Number) : []
					return groupIds.includes(PARTNER_FIRM_GROUP_ID)
				})
			});
		},

		// Tabs that count toward completeness - admin_only tabs (e.g. admin notes) never do
		progressTabs: function () {
			return this.visibleTabs.filter((tab) => tab.tab_type !== ADMIN_ONLY_TAB_TYPE)
		},

		currentSectionValue: {
			get: function () {
				// console.log(this.currentSection)
				return this.currentSection && this.currentSection.value;
			},
			set: function () {
				// Don't do nothing
			}
		},

		questionnaireDataLength: {
			get: function () {
				return Object.keys(this.questionnaire_data).length
			},
			set: function () {
				// Don't do nothing
			}
		},

		sendEmailOnSubmit: function () {
			return this.moduleKey != 'buyer' && this.moduleKey == 'merger-party-data' ? false : true
		},
	
		grow: function () {
			return this.visibleTabs.length > GROW_TABS ? true : false
		},
	
		savingText: function () {
			return this.isAdmin ? 'SAVING' : 'AUTOSAVING'
		},
	
		saveButtonText: function () {
			return this.isAdmin ? 'SAVE DATA' : this.moduleKey === 'entity-maintenance-program-resolutions' ? 'SUBMIT' : 'SUBMIT FOR REVIEW'
		}
	},
	
	watch: {
		$route(to, from) {
			this.getModuleIntro()
			this.gatherData()
			this.getProjectUsers()
			this.getQuestionnaireMenu()
			Object.keys(this.sections).forEach(this.setUnfinishedQuestions)
		},

		questionnaire_values: {
			handler (obj_values) {
				if ( this.intialLoad ) {
					this.intialLoad = false
				} else if (!this.checkReadOnly) {
					const { complete, ...watch_obj_values } = obj_values
					if (Object.keys(watch_obj_values).length > 1) {
						if ( !this.isAdmin ) {
							// Why a promise?  This handler runs before component visibility is determined leading to an edge case where validation can be incorrect.
							// Staging with a promise pushes the validation to the end of the stack allowing visibility and other properties to be set first.
							Promise.resolve().then(() => {
								if (this.currentSection) {
									this.setUnfinishedQuestions(this.currentSectionValue)
								}
							})

							// Initial the autosave
							this.debouncedAutoSave()
						}
					}
				}
	
				// Why a promise?  This handler runs before component visibility is determined leading to an edge case where validation can be incorrect.
				// Staging with a promise pushes the validation to the end of the stack allowing visibility and other properties to be set first.
				// if ( !this.isAdmin ) { 
				// 	Promise.resolve().then(() => {
				// 		if (this.currentSection) {
				// 			this.setUnfinishedQuestions(this.currentSectionValue)
				// 		}
				// 	})
				// }
			},
			deep: true
		},

		questionnaire_data: {
			handler ( obj ) {
				if ( Object.keys(obj).length ) {
					this.show_extraWaiting = false
					this.questionnaireDataLength = Object.keys(obj).length
				}
			},
			deep: true
		},
		
		visibleTabs: function () {
			// Repopulate the nav tabs when visible tabs change
			this.getDirectionalNavData();
		},
	},
	
	methods: {
		debouncedAutoSave: debounce(function () {
			this.autoSaveValues()
		}, 2000),

		adminQuestionniareSave: function () {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			this.autoSaveValues()
		},
		
		handleSubmitReview: function () {
      		window.scrollTo({ top: 0, behavior: 'smooth' })
			this.confirmDialog = true
      		// if (this.moduleKey === 'entity-maintenance-program-resolutions') this.saveValues('true') // Cliff removed so resolutions go thru the same validation process as others
			this.validatingSubmission = true
		},

		navigateToSection: function (section) {
			this.handleTabChange(section)
			this.confirmDialog = false
		},

		formatDateTime ( date ) {
			const options = {
				month: 'numeric', 
				day: 'numeric', 
				year: '2-digit',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
				timeZoneName: 'short'
			}
			return dataTimeDisplayFormatter(date, options)
		},

		calculateCompletedSections () {
			const { sections } = this
			// console.log(sections)

			const completedSections = Object.keys(sections).filter((thisSectionKey) => {
				const thisSection = sections[thisSectionKey]
				if (thisSection.tab_type === ADMIN_ONLY_TAB_TYPE) return false

				return !thisSection.unfinished || thisSection.unfinished.length === 0 && thisSection.visible
			})

			const completedSectionsPercent = completedSections.length / this.progressTabs.length * 100

			this.completedSections = completedSections
			this.completedSectionsPercent = completedSectionsPercent
			this.$emit('questionnaireDisplayProgressUpdated', {
				finished: completedSections.length,
				total: this.progressTabs.length,
				percentage: this.progressTabs.length > 0 ? Math.ceil((completedSections.length / this.progressTabs.length) * 100) : 0
			})
			// console.log('completedSections', this.completedSections)
			// console.log('completedSectionsPercent', this.completedSectionsPercent)
		},

		setUnfinishedQuestions: function (section) {
			const sections = this.sections
			const thisSection = sections[section]
			const { store } = thisSection
			thisSection.unfinished = store.getUnfinishedQuestions({
				values: this.questionnaire_values
			})
			// console.log('unfinishedQuestions', thisSection.unfinished)
			this.calculateCompletedSections()
		},

		emitSavedProgress: function (responseData = {}) {
			const responseProgress = responseData && responseData.questionnaire_progress && typeof responseData.questionnaire_progress === 'object'
				? responseData.questionnaire_progress
				: null
			const responseSections = responseData && Array.isArray(responseData.questionnaire_sections)
				? responseData.questionnaire_sections
				: null

			const fallbackFinished = this.completedSections.length
			const fallbackTotal = this.progressTabs.length

			const finished = Number.isFinite(Number(responseProgress && responseProgress.finished))
				? Number(responseProgress.finished)
				: fallbackFinished
			const total = Number.isFinite(Number(responseProgress && responseProgress.total))
				? Number(responseProgress.total)
				: fallbackTotal

			this.$emit('questionnaireProgressSaved', {
				questionnaire_progress: {
					...(responseProgress || {}),
					finished,
					total,
					ready: typeof (responseProgress && responseProgress.ready) === 'boolean'
						? responseProgress.ready
						: (total > 0 && finished >= total)
				},
				questionnaire_sections: responseSections
			})
		},

		getHeaders: function () {
			return { authentication: Cookie.get('token'), 'Content-Type': 'application/json' }
		},

		exportData: async function ( submitted ) {
			try {
				// console.log('moduleId: '+this.moduleId, 'moduleKey: '+this.moduleKey, 'projectId: '+this.projectId)
				this.resubmitted_questionnaire = submitted == 'resubmitted' ? true : false
				const export_data_rs = await axios.post(`${appUrls.api}/api/export_data`, {
					headers: this.getHeaders(),
					userId: this.isAdmin ? this.userId : Cookie.get('id'),
					moduleKey: this.moduleKey,
					projectId: this.projectId,
					resubmitted: this.resubmitted_questionnaire,
					su: this.isAdmin ? true : sessionStorage.sugar
				})
				
				// console.log(export_data_rs.data.message)
	
			} catch ( error ) {
				console.log(error)
			}
		},

		isComplete: function () {
			const sections = this.sections
			const complete = Object.keys(sections).every((thisSectionKey) => {
				const section = sections[thisSectionKey]
				if (section.tab_type === ADMIN_ONLY_TAB_TYPE) return true
				const { unfinished = [], visible } = section
				const unfinishedRequired = unfinished.filter((thisUnfinished) => thisUnfinished.props && thisUnfinished.props.required)

				return unfinishedRequired.length === 0 || !visible
			})

			return complete
		},

		recalculateProgressForSave: function () {
			const sections = this.sections || {}

			Object.keys(sections).forEach((thisSectionKey) => {
				const thisSection = sections[thisSectionKey]
				if (!thisSection) return

				const { structure, map = {} } = thisSection

				if (structure) {
					thisSection.visible = checkVisibility({
						item: structure,
						model: this.questionnaire_values
					})
				}

				Object.keys(map).forEach((mapKey) => {
					const thisItem = map[mapKey]
					if (!thisItem) return

					thisItem.visible = checkVisibility({
						item: thisItem,
						model: this.questionnaire_values
					})
				})
			})

			Object.keys(sections).forEach((thisSectionKey) => {
				const thisSection = sections[thisSectionKey]
				if (!thisSection || !thisSection.store) return

				thisSection.unfinished = thisSection.store.getUnfinishedQuestions({
					values: this.questionnaire_values
				})
			})

			this.calculateCompletedSections()

			const finished = this.completedSections.length
			const total = this.progressTabs.length
			const ready = total > 0 ? finished >= total : false

			return {
				finished,
				total,
				ready
			}
		},

		autoSaveValues: async function () {
			try {
				if ( this.isQuestionsOnly ) return

				this.isAutoSaving = true
				const progressSnapshot = this.recalculateProgressForSave()
				const complete = this.isComplete()
				const progress = {
					...progressSnapshot,
					ready: complete
				}

				const auto_saved = await axios.post(`${appUrls.api}/api/save_form_data`, {
					headers: this.getHeaders(),
					data: Object.entries(
						Object.assign(
							{},
							{
							complete
							},
							this.questionnaire_values
						)
					),
					section: this.currentSectionValue,
					progress,
					userId: this.isAdmin ? this.userId : Cookie.get('id'),
					moduleId: this.moduleId,
					moduleKey: this.moduleKey,
					projectId: this.projectId,
					su: this.isAdmin ? true : sessionStorage.sugar,
					parentProjectId: this.parentProjectId,
				})

				if ( auto_saved.data.outcome ) {
					this.emitSavedProgress(auto_saved.data)
					// SUCCESS DIALOG W/ MESSAGE
					setTimeout(() => {
						this.last_saved = this.formatDateTime(auto_saved.data.date_saved)
						// this.checkCanSubmit();
						this.getCurrentProject()
						this.isAutoSaving = false
					}, 3500)
				} else {
					// FAILED DIALOG W/ MESSAGE
					this.isAutoSaving = false
				}
			} catch (err) {
				console.log(err)
			}
		},

		saveValues: async function (submit) {
			// console.log('resolutionData', this.resolutionData)
			try {
				if ( this.isQuestionsOnly ) return

				const isSubmit = submit !== undefined

				if (isSubmit) {
					this.confirmDialog = false
				}

				const progressSnapshot = this.recalculateProgressForSave()
				const complete = this.isComplete()
				const progress = {
					...progressSnapshot,
					ready: complete
				}

				const submit_save = await axios.post(`${appUrls.api}/api/save_form_data`, {
					headers: this.getHeaders(),
					data: Object.entries(
						Object.assign(
							{},
							{
								complete
							},
							this.questionnaire_values
						)
					),
					progress,
					section: this.currentSectionValue,
					userId: this.isAdmin ? this.userId : Cookie.get('id'),
					moduleId: this.moduleId,
					moduleKey: this.moduleKey,
					projectId: this.projectId,
					review: submit,
					su: this.isAdmin ? true : sessionStorage.sugar,
					parentProjectId: this.parentProjectId,
					resolutionData: this.resolutionData,
					resolutionSave: true
				})

				// console.log(submit_save.data)
				if ( submit_save.data.outcome ) {
					this.emitSavedProgress(submit_save.data)
					// SUCCESS DIALOG W/ MESSAGE
					if ( submit_save.data.project_status !== 'open' ) {
						if ( this.sendEmailOnSubmit ) this.exportData( submit )

						if ( this.moduleKey === 'entity-maintenance-program-resolutions' ) {
							this.$router.push(`/module_roadmap/entity-maintenance-program/${this.parentProjectId}`)
							return
						}
						this.$router.push(`/submitted_questionnaire/${this.moduleKey}/${this.projectId}/${this.resubmitted_questionnaire ? 'resubmitted' : 'submitted'}`)

					} else {
						this.last_saved = this.formatDateTime(submit_save.data.date_saved)
						// this.checkCanSubmit();
						this.getCurrentProject()

						this.feedback_type = 'accent'
						this.feedback_msg = submit_save.data.message
						this.saveDialog = true
						this.closeFeedbackDialog(submit_save.data.status)
					}
				} else {
					// FAILED DIALOG W/ MESSAGE
					this.feedback_type = 'warning'
					this.feedback_msg = submit_save.data.message
					this.saveDialog = true
					this.closeFeedbackDialog(submit_save.data.status)
				}
			} catch (err) {
				console.log(err)
			}
		},

		getDirectionalNavData () {
			const nav_tabs = []

			const thisTab = this.currentSection
			const index = this.visibleTabs.indexOf(thisTab)
			const previousSection = this.visibleTabs[index - 1]
			const nextSection = this.visibleTabs[index + 1]
			const current = {
				title: '',
				value: thisTab.value,
				color: 'grey--text'
			}

			if (previousSection) {
				nav_tabs.push({
					title: 'PREV SECTION',
					value: previousSection.value,
					color: 'primary--text'
				})
			}

			nav_tabs.push(current)

			if (nextSection) {
				nav_tabs.push({
					title: 'NEXT SECTION',
					value: nextSection.value,
					color: 'primary--text'
				})
			} else {
				if (this.isQuestionsOnly) {
					nav_tabs.push(current)
				} else if (this.moduleKey !== 'buyer' && this.checkReadOnly) {
					nav_tabs.push(current)
				} else {
					nav_tabs.push({
						title: this.moduleKey === 'buyer' ? 'UPDATE PROFILE' : this.saveButtonText,
						value: '',
						color: 'primary--text'
					})
				}
			}
			this.nav_tabs = nav_tabs
		},

		beginQuestionnaire: function () {
			if ( this.isQuestionsOnly || !this.projectId ) return

			axios.put(`${appUrls.api}/api/update_intro/${this.projectId}`, {
				headers: this.getHeaders()
			})
			.then(res => {
				// this.intro_visible = 'd-none'; // THESE ARE NOT USED UNTIL LATER - CHANGES ARE IN PROPS, NOT HERE
				// this.questionnaire_visible = 'd-block'; // THESE ARE NOT USED UNTIL LATER - CHANGES ARE IN PROPS, NOT HERE
			})
			.catch(function (error) {
				console.log(error)
			})
		},

		fetchQuestionnaireData: async function (module) {
			const res = await axios.get(`${appUrls.api}/api/module_structure/${this.moduleKey}/${module}`, {
				headers: this.getHeaders()
			})

			const { data = {} } = res
			const { outcome, structure } = data

			if (outcome) {
				return structure
			}
		},

		getQuestionnaireData: function (module) {
			return Promise.resolve(this.sections[module].structure)
		},

		getModuleIntro: async function () {
			try {
				const getModuleInfo = await axios.get(`${appUrls.api}/api/module_info/${this.moduleKey}`, {
					headers: this.getHeaders()
				})
				
				if ( getModuleInfo.data ) {
					// console.log(getModuleInfo.data)
					this.questionnaire_intro = getModuleInfo.data.info
				}
			} catch ( error ) {
				console.log(error)
			}
		},

		// item is the object to set visibility on
		// structure is the object to check dependencies on
		// for a question, item and structure are the same
		// for a section, item is the section, structure is the questionnaire
		watchDependencies: function (item, structure = item) {
			const self = this
			const { dependencies } = structure

			function setVisibility () {
				const isVisible = checkVisibility({
					item: structure,
					model: self.questionnaire_values
				})

				item.visible = isVisible
			}

			function watchItem(dep) {
				const { items, name } = dep;

				if (items) {
					// Recursively watch nested dependencies
					items.forEach(watchItem);
				}

				setVisibility();
				self.$watch(() => self.questionnaire_values[name], setVisibility);
			}

			if (dependencies) {
				dependencies.items.forEach(thisDep => watchItem(thisDep));
			} else {
				item.visible = true
			}
		},

		getSectionDataByTab: async function (tab, index) {
			const self = this
			const { value } = tab

			// Fetch all the section data
			const structure = await self.fetchQuestionnaireData(value)
			const store = new Store({
				structure,
				values: self.questionnaire_values
			})
			const map = store.getMap()

			for (const key in map) {
				const thisItem = map[key];

				self.watchDependencies(thisItem);
			}

			const sectionData = {
				index,
				structure,
				map,
				required: store.getRequired(),
				store,
				...tab
			}

			// Cache the section data and index on the sections data object
			self.sections[value] = sectionData

			return sectionData;
		},

		getQuestionnaireMenu: async function () {
			const self = this
			const menuPath = this.isQuestionsOnly
				? `${appUrls.api}/api/questionnaire_preview_menu/${this.moduleKey}`
				: `${appUrls.api}/api/questionnaire_menu/${this.moduleKey}/${this.projectId}`

			const res = await axios.get(menuPath, {
				headers: this.getHeaders()
			})

			const { tabs } = res.data
			const dataPromises = tabs.map(this.getSectionDataByTab)

			// Wait to display menu until all sections have been fetched
			const sectionData = await Promise.all(dataPromises)

			self.tabs = sectionData.map((thisSectionData) => {
				const { index, title, value, structure, tab_type } = thisSectionData

				self.watchDependencies(thisSectionData, structure)

				return {
					index,
					section: thisSectionData,
					title,
					value,
					tab_type
				}
			})

			self.selectTabByIndex(0)

			return sectionData
		},

		gatherData: async function () {
			if ( this.isQuestionsOnly || !this.projectId ) {
				this.last_saved = ''
				this.questionnaire_values = {}
				return
			}

			const dataObj = {}
			const res = await axios.get(`${appUrls.api}/api/user_data/${this.projectId}`, {
				headers: this.getHeaders()
			})

			let latestSavedDate = null

			for (const { section, question, value_type, answer, date_saved } of res.data.values) {
				const key = `${section}_${question}`

				if (date_saved) {
					const parsedDate = new Date(date_saved)
					if (!Number.isNaN(parsedDate.getTime()) && (!latestSavedDate || parsedDate > latestSavedDate)) {
						latestSavedDate = parsedDate
					}
				}

				if (value_type === 'object' && answer != '') {
					dataObj[key] = safeParseJson(answer, answer)
				} else {
					dataObj[key] = answer
				}
			}

			this.last_saved = latestSavedDate ? this.formatDateTime(latestSavedDate) : ''

			this.questionnaire_values = Object.assign(
				{},
				this.questionnaire_values,
				dataObj
			)
		},

		getUserInfo: async function () {
			const { data: userInfo } = await axios.get(`${appUrls.api}/api/account/${Cookie.get('id')}`, {
				headers: this.getHeaders()
			});

			// Save the user info to the questionnaire store for use in other components (checkVisibility)
			questionnaireStore.userInfo = userInfo.contact;
			// console.log(questionnaireStore)
		},

		getProjectUsers: async function () {
			if ( this.isQuestionsOnly || !this.projectId ) {
				this.projectUsers = []
				return
			}

			try {
				const { data } = await axios.get(`${appUrls.api}/api/project_users/${this.projectId}`, {
					headers: this.getHeaders()
				})

				this.projectUsers = data && data.outcome && Array.isArray(data.users) ? data.users : []
			} catch (error) {
				console.log(error)
				this.projectUsers = []
			}
		},

		closeFeedbackDialog: function () {
			setTimeout(() => {
				this.saveDialog = false
			}, 3500)
		},

		handleTabChange: async function (tabName) {
			const self = this;
			this.questionnaire_data = {}

			// Set the current tab to active
			this.tabs.forEach((thisTab) => {
				thisTab.active = thisTab.value === tabName

				if (thisTab.active) {
					self.currentSection = thisTab;
				}
			});

			// When a tab is changed we will fetch the questionnaire data for the requested form
			const questionnaireData = await this.getQuestionnaireData(tabName)

			this.questionnaire_data = questionnaireData
			this.getDirectionalNavData()
		},

		selectTabByIndex: function (index) {
			const section = this.tabs[index].value

			if (section) {
				this.handleTabChange(section)
			}
		},

		hardRefresh: async function () {
			const refresh_reset = await this.updateRefreshValue()

			if ( refresh_reset ) {
				window.location.reload(true)
			}
		},

		updateRefreshValue: async function () {
			if ( this.isQuestionsOnly || !this.projectId ) return false

			const refresh_reset_rs = await axios.put(`${appUrls.api}/api/reset_refresh/${this.projectId}`, {
				headers: this.getHeaders()
			});

			return refresh_reset_rs.data.reset
		}
	},
	
	created () {
		this.isAdmin = ['admin', '8081'].some(el => window.location.origin.includes(el))
	},
	
	async mounted () {
		if ( this.needsHardRefresh && !this.isQuestionsOnly ) {
			this.hardRefresh()
		}

		// Show extra waiting message after 10 seconds
		setTimeout( () => {
			this.show_extraWaiting = true
		}, 10000)

		// gather data before getting the questionnaire menu
		await Promise.all([
			this.getModuleIntro(),
			this.gatherData(),
			this.getUserInfo(),
			this.getProjectUsers()
		]);

		await this.getQuestionnaireMenu()
		// console.log(this.questionnaireUserGroupIDs)
		this.isPartner = this.questionnaireUserGroupIDs && this.questionnaireUserGroupIDs.includes(PARTNER_FIRM_GROUP_ID)

		Object.keys(this.sections).forEach(this.setUnfinishedQuestions)
	}
}
</script>

<style scoped>
	.act_tb{
		font-weight: bold;
		/* background-color: #CCEAED; */
	}
	.bottom_border {
		border-top: 2px solid #EFEFEF;
	}
	.waiting_text {
		font-family: 'SansationLight';
		font-size: 1rem !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/questionnaire.vue